module.exports = __webpack_public_path__ + "assets/images/c7a5949d4271e5aa6bd9055dd5cd4d58.svg";